module.exports = __webpack_public_path__ + "static/img/RSFUPS116_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSFUPS116_1.png
// module id = CKoD
// module chunks = 0